import { render, staticRenderFns } from "./ui-color.vue?vue&type=template&id=564d9e94&scoped=true"
import script from "./ui-color.vue?vue&type=script&lang=js"
export * from "./ui-color.vue?vue&type=script&lang=js"
import style0 from "./ui-color.vue?vue&type=style&index=0&id=564d9e94&prod&lang=css"
import style1 from "./ui-color.vue?vue&type=style&index=1&id=564d9e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d9e94",
  null
  
)

export default component.exports